import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";
import { Download as DownloadIcon } from "@mui/icons-material";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import {Table,TableBody,TableCell,TableContainer,TableHead,Button,TableRow,Paper,Typography,CircularProgress,Box,} from "@mui/material";

const login_id = localStorage.getItem("LOGIN_ID");
const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

const BandhanReport = () => {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);

  
  const login_id = localStorage.getItem("LOGIN_ID");
  const user_branch = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");
  const fetchReport = async () => {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const res = await axios.post(`${BASE_URL}/getReport`, {
       branch:user_branch,login_id:login_id
      });

      Swal.close();

      if (res.data && res.data.length > 0) {
        setReport(res.data);
      } else {
        Swal.fire("Info", "No report data found", "info");
      }
    } catch (error) {
      Swal.close();
      console.error("Error fetching Bandhan report:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  const handleDownloadTable = () => {
    if (report.length === 0) {
      Swal.fire("Info", "No data to download", "info");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bandhan Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "bandhan_Report.xlsx");
  };

  return (
    <div className="p-4">
      {/* <Typography variant="h6" gutterBottom fontWeight="bold">
        Bandhan Report
      </Typography> */}

      <Box mb={3}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadTable}
        >
          Download Excel
        </Button>
      </Box>

      {loading ? (
        <CircularProgress />
      ) : report.length === 0 ? (
        <Typography>No records found</Typography>
      ) : (
        <TableContainer component={Paper} elevation={3}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#add8e6" }}>
              <TableRow>
                <TableCell><b>Branch</b></TableCell>
                <TableCell><b>Mechanic Code</b></TableCell>
                <TableCell><b>Mechanic Name</b></TableCell>
                <TableCell><b>Mobile</b></TableCell>
                <TableCell><b>Dealer Code</b></TableCell>
                <TableCell><b>Dealer Name</b></TableCell>
                <TableCell><b>MS1</b></TableCell>
                <TableCell><b>Redeemed</b></TableCell>
                <TableCell><b>MS2</b></TableCell>
                <TableCell><b>MS3</b></TableCell>
                <TableCell><b>MS4</b></TableCell>
                <TableCell><b>MS7</b></TableCell>
                <TableCell><b>Balance</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.branch_code}</TableCell>
                  <TableCell>{row.new_mechanic_code}</TableCell>
                  <TableCell>{row.mechanic_name}</TableCell>
                  <TableCell>{row.mobile}</TableCell>
                  <TableCell>{row.dealer_code}</TableCell>
                  <TableCell>{row.user_name}</TableCell>
                  <TableCell>{row.scheme_point_one}</TableCell>
                  <TableCell>{row.redeemed_points}</TableCell>
                  <TableCell>{row.scheme_point_two}</TableCell>
                  <TableCell>{row.scheme_point_three}</TableCell>
                  <TableCell>{row.scheme_point_four}</TableCell>
                  <TableCell>{row.scheme_point_seven}</TableCell>
                  <TableCell>
                    {(
                      row.scheme_point_one +
                      row.scheme_point_two +
                      row.scheme_point_three +
                      row.scheme_point_four -
                      row.redeemed_points
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default BandhanReport;
